import { render, staticRenderFns } from "./EntitiesCard.vue?vue&type=template&id=21de849f&scoped=true"
import script from "./EntitiesCard.vue?vue&type=script&lang=js"
export * from "./EntitiesCard.vue?vue&type=script&lang=js"
import style0 from "./EntitiesCard.vue?vue&type=style&index=0&id=21de849f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21de849f",
  null
  
)

export default component.exports